import * as React from 'react';
import { Layout, Button } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import {
	getProtectedImageUriForBuyer,
	getProtectedImageUriFromString,
} from '../../utils/FileAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Carousel, { Modal as Lightbox, ModalGateway } from 'react-images';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import { generateBackLink } from '../../utils/HistoryUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/locations_actions';
import { updatePaginationEntities } from '../../thunks/thunks_wrapper';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import posthog from 'posthog-js';

require('./LocationsDetailPage.less');
const queryString = require('qs');
const { Content } = Layout;

class LocationsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			targetCollectionName: null,
		};
	}

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	componentDidMount() {
		const { getLocation, updateNavbar, match, location, wolocation } = this.props;
		const locationId = match.params.id;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		updateNavbar('Back to Locations', generateBackLink('/buyer/locations/overview/all', location));
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({
				fromTargetCollectionName: queryParams.targetCollectionName,
			});
		}
		if (queryParams.backlinkParams) {
			this.setState({
				loading: false,
				backLinkTo: `/buyer/locations/overview/all?${queryParams.backlinkParams}`,
			});
		} else {
			this.setState({
				loading: false,
				backLinkTo: `/buyer/locations/overview/all`,
			});
		}
		if (!(wolocation && wolocation.id)) {
			getLocation(locationId);
		}
	}
	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	handleTabChange = (key) => {
		const { history, match } = this.props;
		const locationId = match.params.id;
		history.push(`/buyer/locations/detail/${locationId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteLocation, wolocation } = this.props;
		deleteLocation(wolocation).then(() => {
			history.push('/buyer/locations/overview/all');
		});
	};

	onEditClick = () => {
		const { history, match } = this.props;
		const locationId = match.params.id;
		history.push(`/buyer/locations/edit/${locationId}`);
	};

	render() {
		const {
			wolocation,
			match,
			history,
			location,
			locations,
			updatePagination,
			cloneTargetCollection,
		} = this.props;
		const locationId = match.params.id;
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'meters',
				name: 'Meter Readings',
			},
			{
				key: 'suppliers',
				name: 'Suppliers',
			},
			{
				key: 'audit',
				name: 'Audit Logs',
			},
		];

		if (posthog.isFeatureEnabled('wiki')) {
			tabs.push({
				key: 'documents',
				name: 'Documents',
			});
		}
		let photoUris = [];
		let lightboxPhotoUris = [];
		if (wolocation.images) {
			photoUris = wolocation.images.slice(0, 4).map((locImg) => {
				const [imgFileId, imgFileName] = locImg.split('/');
				return getProtectedImageUriForBuyer(imgFileId, imgFileName, 1200, 800);
			});
			lightboxPhotoUris = wolocation.images.map((photoString) => ({
				src: getProtectedImageUriFromString(ROLE_TYPES.BUYER)(photoString, 2400, 1600),
			}));
		}
		return (
			<div>
				<Route
					path="/buyer/locations/detail/:id"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/buyer/locations/detail/${locationId}/details`,
							}}
						/>
					)}
				/>
				<Content className="locationsDetailPage">
					{/*<ScrollToTopOnMount/>*/}
					{/*<BackTop/>*/}
					<ModalGateway>
						{this.state.lightboxIsOpen ? (
							<Lightbox onClose={this.closeLightbox}>
								<Carousel
									trackProps={{
										onViewChange: this.handleViewChange,
									}}
									views={lightboxPhotoUris}
									currentIndex={this.state.currentIndex}
								/>
							</Lightbox>
						) : null}
					</ModalGateway>

					<div className="imageLayout">
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`imageLayout__gradientOverlay ${
								wolocation.isActive ? '' : 'imageLayout__gradientOverlay--darker'
							}`}
						>
							{!wolocation.isActive ? <div className="locationInactiveLabel">Inactive</div> : null}
							<div className="locationsDetailPage__overtitle">
								{nullSafeGet('locationType.name', wolocation)} {nullSafeGet('storeId', wolocation)}
							</div>
							<h4 className="locationsDetailPage__title">{wolocation.name}</h4>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
							<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LOCATIONS}>
								<div style={{ position: 'absolute', top: 40, right: 40 }}>
									<OWButtonWithSupplierManagedLock ghost={true} onClick={this.onEditClick}>
										Edit
									</OWButtonWithSupplierManagedLock>
									{/*<Button ghost={true} onClick={this.handleDelete}>Delete</Button>*/}
								</div>
							</AccessPermissionChecker>
							<div
								style={{ position: 'absolute', bottom: 40, right: 40 }}
								className="flex flex-row items-baseline"
							>
								{lightboxPhotoUris.length > 0 ? (
									<Button
										style={{ color: 'white', marginRight: 16 }}
										type="ghost"
										onClick={() => this.openLightbox()}
									>
										View Photos
									</Button>
								) : null}
								<NextPreviousButton
									key={this.state.fromTargetCollectionName}
									location={location}
									history={history}
									activeId={nullSafeGet('id', wolocation)}
									getEnitityUrl={(id) => `/buyer/locations/detail/${id}/details`}
									stateSlice={locations}
									targetCollectionName={this.state.fromTargetCollectionName}
									updatePagination={updatePagination}
									cloneTargetCollection={cloneTargetCollection}
									entityName="location"
								/>
							</div>
						</div>
					</div>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	wolocation: getEntityById(ownProps.match.params.id, state.locations),
	match: ownProps.match,
	history: ownProps.history,
	locations: state.locations,
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(locationsRestCrudThunksForBuyer.readOne(id)),
	deleteLocation: (entity) =>
		dispatch(locationsRestCrudThunksForBuyer.delete(entity, 'id', null, true)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	cloneTargetCollection: (from, to) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationEntities('buyer', 'locations', locationsRestCrudThunksForBuyer)(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationsDetailPage));
